

import { FormComponent } from 'components/FormComponent';
import { SelectOption } from 'components/FormComponent/Select';

import { SearchBar } from '../SearchBar/SearchBar';

import { ChipFilterBar } from './ChipFilterBar';
import { FilterButtons } from './FilterButtons';
import { ActiveFilters, FilterGroup } from './types';

type FilterAndSearchRowProps = {
  filterGroups: FilterGroup<any>[];
  activeFilters: ActiveFilters;
  handleFilterChange: (groupId: string, filterName: string | null) => void;
  query: string;
  setQuery: (query: string) => void;
  hideSearch?: boolean;
  useDropdown?: boolean; // Whether to use dropdown instead of filter buttons
  useChipFilters?: boolean; // Whether to use chip-style filters ("+ Add filter" + chips)
};

/**
 * Filter and search bar row
 * @param param0
 * @returns
 */
export const FilterAndSearchRow = ({
  filterGroups,
  activeFilters,
  handleFilterChange,
  query,
  setQuery,
  hideSearch,
  useDropdown = false,
  useChipFilters = false,
}: FilterAndSearchRowProps) => {
  const renderFilters = () => {
    if (filterGroups.length === 0) {
      return <div className="placeholder" />;
    }

    if (useChipFilters) {
      return (
        <ChipFilterBar
          filterGroups={filterGroups}
          activeFilters={activeFilters}
          handleFilterChange={handleFilterChange}
        />
      );
    }

    if (useDropdown) {
      return (
        <div style={{ minWidth: '20rem' }}>
          {filterGroups.map(({ groupId, filters }) => {
            const options: SelectOption[] = filters.map((filter) => ({
              value: filter.name,
              label: filter.name,
            }));
            const currentValue = activeFilters[groupId] ? {
              value: activeFilters[groupId],
              label: activeFilters[groupId],
            } : null;

            return (
              <FormComponent.ReactSelect
                key={groupId}
                options={options}
                value={currentValue}
                onChange={(newValue) => {
                  const option = newValue as SelectOption | null;
                  if (option) {
                    handleFilterChange(groupId, option.value);
                  }
                }}
                isSearchable={true}
              />
            );
          })}
        </div>
      );
    }

    return (
      <FilterButtons
        filterGroups={filterGroups}
        handleFilterChange={handleFilterChange}
        activeFilters={activeFilters}
      />
    );
  };

  return (
    <div className="flex flex-row justify-between gap-4">
      {renderFilters()}
      {!hideSearch && <SearchBar query={query} setQuery={setQuery} />}
    </div>
  );
};
